var map = {
	"./nkp-logo-en.svg": "f9df",
	"./nkp-logo.svg": "0458",
	"./nkp_logo.png": "f590",
	"./nkp_logo_en.png": "1bdf",
	"./payment_methods/payment_icon_banktransfer.png": "b013",
	"./payment_methods/payment_icon_csobgtw.png": "d037",
	"./payment_methods/payment_icon_gpwebpay.png": "e581",
	"./products/placeholder-min.png": "2833"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";